import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import decode from "jwt-decode";
import { request } from "@/js/http/http_request";
import { getFilters, setGlobalFilters } from "@/js/filter/filter.js";
import { CURRENT_ORDER, CURRENT_PAYMENT, THIRD_PARTY_USER_SELECTED } from "@/js/order/order.js";
var ID_USER_KEY = "id_user";
var ID_TOKEN_KEY = "id_token";
var ACCESS_TOKEN_KEY = "access_token";
var REFRESH_TOKEN_KEY = "refresh_token";
var helper = require("./http_request");
export function getIdUserFromSession() {
  return sessionStorage.getItem(ID_USER_KEY);
}
export function getIdToken() {
  return localStorage.getItem(ID_TOKEN_KEY);
}
export function getAccessToken() {
  return localStorage.getItem(ACCESS_TOKEN_KEY);
}
export function getRefreshToken() {
  return localStorage.getItem(REFRESH_TOKEN_KEY);
}
export function clearIdToken() {
  localStorage.removeItem(ID_TOKEN_KEY);
}
export function clearTokens() {
  localStorage.removeItem(ACCESS_TOKEN_KEY);
  localStorage.removeItem(REFRESH_TOKEN_KEY);
}
// Get and store access_token in local storage
export function setAccessToken(accessToken) {
  localStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
}

// Get and store refresh_token in local storage
export function setRefreshToken(refreshToken) {
  localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
}

// Get and store id_token in local storage
export function setIdToken(idToken) {
  localStorage.setItem(ID_TOKEN_KEY, idToken);
}
export function setIdUserInSession() {
  sessionStorage.setItem(ID_USER_KEY, getIdUserFromToken());
}
export function getTokenExpirationDate(encodedToken) {
  if (!encodedToken) return null;
  var token = decode(encodedToken);
  if (!token.exp) {
    return null;
  }
  var date = new Date(0);
  date.setUTCSeconds(token.exp);
  return date;
}
export function getLoggedUserData() {
  try {
    return {
      idUser: getIdUserFromToken(),
      userGroup: getUserGroupFromToken(),
      isSuperAdmin: isSuperAdmin(),
      isConsultant: isConsultantOrHolding(),
      isSalesman: isSalesman(),
      isHolding: isHolding(),
      isAttachToHolding: isAttachToHolding(),
      isPricePostingUsaProSubmittedByPriceCoherence: isPricePostingUsaProSubmittedByPriceCoherence(),
      rangeAccessibility: rangeAccessibility(),
      attachedRangeAccessibility: attachedRangeAccessibility(),
      limitedLocations: getLimitedLocations()
    };
  } catch (_) {
    return {
      idUser: 0,
      userGroup: "",
      isSuperAdmin: false,
      isConsultant: false,
      isSalesman: false,
      isHolding: false,
      isAttachToHolding: false,
      isPricePostingUsaProSubmittedByPriceCoherence: false,
      rangeAccessibility: null,
      attachedRangeAccessibility: null,
      limitedLocations: null
    };
  }
}
export function getIdUserFromToken() {
  var token = decode(getAccessToken());
  return token.nameid;
}
export function getUserGroupFromToken() {
  var token = decode(getAccessToken());
  return token.groupsid;
}
export function isBuyerGroup(groupid) {
  return groupid == "USER" || groupid == "HORECA" || groupid == "WHOLESALER";
}
export function isUserBuyerGroup(loggedUserData) {
  var _loggedUserData$userG;
  var groupid = (_loggedUserData$userG = loggedUserData === null || loggedUserData === void 0 ? void 0 : loggedUserData.userGroup) !== null && _loggedUserData$userG !== void 0 ? _loggedUserData$userG : getUserGroupFromToken();
  return isBuyerGroup(groupid);
}
export function isRefreshTokenExpired() {
  return isTokenExpired(getRefreshToken());
}
export function isAccessTokenExpired() {
  return isTokenExpired(getAccessToken());
}
export function isTokenExpired(token) {
  var expirationDate = getTokenExpirationDate(token !== null && token !== void 0 ? token : getAccessToken());
  return expirationDate < new Date();
}
export function getAuthHeaderFromStorage() {
  return "Bearer " + getAccessToken();
}
export function getAuthHeaderFromToken(accessToken) {
  return "Bearer " + accessToken;
}
export function hasRole(role) {
  var token = decode(getAccessToken());
  return token.role.includes(role);
}
export function isTenantOwner() {
  var token = decode(getAccessToken());
  return token.tenant_type == "owner";
}
export function hasVineyardAccessManagement(vineyardId) {
  var token = decode(getAccessToken());
  return token.vam.includes(vineyardId);
}
export function hasBypassBuyLimit() {
  var token = decode(getAccessToken());
  return token.has_bypass_buy_limit;
}
export function isAllowedOrderWithoutPayment() {
  var token = decode(getAccessToken());
  return token.is_allowed_order_without_payment;
}
export function isSuperAdmin(loggedUserData) {
  if (!!loggedUserData) {
    return loggedUserData.isSuperAdmin;
  } else {
    var token = decode(getAccessToken());
    return token.is_super_admin;
  }
}
export function isAdminNotConsultant(loggedUserData) {
  var _loggedUserData$userG2;
  var groupid = (_loggedUserData$userG2 = loggedUserData === null || loggedUserData === void 0 ? void 0 : loggedUserData.userGroup) !== null && _loggedUserData$userG2 !== void 0 ? _loggedUserData$userG2 : getUserGroupFromToken();
  return groupid == "ADMIN" && !isConsultantOrHolding(loggedUserData);
}
export function isSalesman(loggedUserData) {
  if (!!loggedUserData) {
    return loggedUserData.isSalesman;
  } else {
    var token = decode(getAccessToken());
    return token.is_salesman;
  }
}
export function isConsultantOrHolding(loggedUserData) {
  if (!!loggedUserData) {
    return loggedUserData.isConsultant;
  } else {
    var token = decode(getAccessToken());
    return token.is_consultant;
  }
}
export function isHolding(loggedUserData) {
  if (!!loggedUserData) {
    return loggedUserData.isHolding;
  } else {
    var token = decode(getAccessToken());
    return token.is_holding;
  }
}
export function isConsultantNotHolding(loggedUserData) {
  return isConsultantOrHolding(loggedUserData) && !isHolding(loggedUserData);
}
export function isAttachToHolding(loggedUserData) {
  if (!!loggedUserData) {
    return loggedUserData.isAttachToHolding;
  } else {
    var token = decode(getAccessToken());
    return token.is_attach_to_holding;
  }
}
export function isPricePostingUsaProSubmittedByPriceCoherence(loggedUserData) {
  if (!!loggedUserData) {
    return loggedUserData.isPricePostingUsaProSubmittedByPriceCoherence;
  } else {
    var token = decode(getAccessToken());
    return token.is_price_posting_usa_pro_submitted_by_price_coherence;
  }
}
export function rangeAccessibility(loggedUserData) {
  if (!!loggedUserData) {
    return loggedUserData.rangeAccessibility;
  } else {
    var token = decode(getAccessToken());
    return token.range_accessibility;
  }
}
export function attachedRangeAccessibility(loggedUserData) {
  if (!!loggedUserData) {
    return loggedUserData.attachedRangeAccessibility;
  } else {
    var token = decode(getAccessToken());
    return token.attached_range_accessibility;
  }
}
export function getLimitedLocations(loggedUserData) {
  if (!!loggedUserData) {
    return loggedUserData.limitedLocations;
  } else {
    var token = decode(getAccessToken());
    if (token.limited_locations) {
      return JSON.parse(token.limited_locations);
    } else {
      return null;
    }
  }
}
export function hasLimitedLocations(loggedUserData) {
  if (!!loggedUserData) {
    var _loggedUserData$limit;
    return ((_loggedUserData$limit = loggedUserData.limitedLocations) === null || _loggedUserData$limit === void 0 ? void 0 : _loggedUserData$limit.length) > 0;
  } else {
    var token = decode(getAccessToken());
    if (token.limited_locations) {
      var _JSON$parse;
      return ((_JSON$parse = JSON.parse(token.limited_locations)) === null || _JSON$parse === void 0 ? void 0 : _JSON$parse.length) > 0;
    } else {
      return false;
    }
  }
}
export function isAddressNotLimited(loggedUserData, countryId) {
  var stateId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var limitedLocations = getLimitedLocations(loggedUserData);
  if (!(limitedLocations !== null && limitedLocations !== void 0 && limitedLocations.length)) return true;
  var isAllowed = limitedLocations.some(function (loc) {
    return loc.country_id === countryId && (!loc.state_id || loc.state_id === stateId);
  });
  return isAllowed;
}
export function isProfessional(loggedUserData) {
  var _loggedUserData$userG3;
  var groupid = (_loggedUserData$userG3 = loggedUserData === null || loggedUserData === void 0 ? void 0 : loggedUserData.userGroup) !== null && _loggedUserData$userG3 !== void 0 ? _loggedUserData$userG3 : getUserGroupFromToken();
  return groupid == "HORECA";
}
export function isIndividual(loggedUserData) {
  var _loggedUserData$userG4;
  var groupid = (_loggedUserData$userG4 = loggedUserData === null || loggedUserData === void 0 ? void 0 : loggedUserData.userGroup) !== null && _loggedUserData$userG4 !== void 0 ? _loggedUserData$userG4 : getUserGroupFromToken();
  return groupid == "USER";
}
export function isWholesaler(loggedUserData) {
  var _loggedUserData$userG5;
  var groupid = (_loggedUserData$userG5 = loggedUserData === null || loggedUserData === void 0 ? void 0 : loggedUserData.userGroup) !== null && _loggedUserData$userG5 !== void 0 ? _loggedUserData$userG5 : getUserGroupFromToken();
  return groupid == "WHOLESALER";
}
export function isHorecaUs(_x) {
  return _isHorecaUs.apply(this, arguments);
}
function _isHorecaUs() {
  _isHorecaUs = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(loggedUserData) {
    var user;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (isProfessional(loggedUserData)) {
            _context.next = 4;
            break;
          }
          return _context.abrupt("return", false);
        case 4:
          _context.next = 6;
          return getUserLogged();
        case 6:
          user = _context.sent;
          return _context.abrupt("return", user.delivery_address.country.iso_code === "USA");
        case 8:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _isHorecaUs.apply(this, arguments);
}
export function isHorecaOrWholesalerOrHoldingUs(_x2) {
  return _isHorecaOrWholesalerOrHoldingUs.apply(this, arguments);
}
function _isHorecaOrWholesalerOrHoldingUs() {
  _isHorecaOrWholesalerOrHoldingUs = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(loggedUserData) {
    var user;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          if (!(!isProfessional(loggedUserData) && !isWholesaler(loggedUserData) && !isHolding(loggedUserData))) {
            _context2.next = 4;
            break;
          }
          return _context2.abrupt("return", false);
        case 4:
          _context2.next = 6;
          return getUserLogged();
        case 6:
          user = _context2.sent;
          return _context2.abrupt("return", user.delivery_address.country.iso_code === "USA");
        case 8:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _isHorecaOrWholesalerOrHoldingUs.apply(this, arguments);
}
export function getUserLogged() {
  return request("/v1/user", "get", null, true, "api").then(function (response) {
    return response.data;
  }).catch(function (e) {
    return e;
  });
}
export function disconnect() {
  var isUserAdmin = isAdminNotConsultant();
  var data = {
    token: getRefreshToken(),
    client_id: window.whitelabel.clientId,
    client_secret: window.whitelabel.clientSecret
  };
  helper.request("/v1/gate/token/revoke", "post", data, false, "cap").finally(function () {
    clearStorage(isUserAdmin);
    window.location.pathname = "login";
  });
}
export function clearStorage(isUserAdmin) {
  var tempFilters = getFilters();
  localStorage.clear();
  if (isUserAdmin) {
    setGlobalFilters(tempFilters);
  }
}
export function cleanStorageLogin() {
  localStorage.removeItem(THIRD_PARTY_USER_SELECTED);
  localStorage.removeItem(CURRENT_ORDER);
  localStorage.removeItem(CURRENT_PAYMENT);
}
export function getClientAppData(_this) {
  return {
    client_id: _this.$whitelabel.clientId,
    client_secret: _this.$whitelabel.clientSecret
  };
}